import { ColorMode } from "@/types";
import { createContext } from "react";

type ColorModeContext = {
  colorMode: ColorMode;
  toggleColorMode: () => void;
};

export const ColorModeContext = createContext<ColorModeContext | null>(null);
